import { AppState } from '@/lib/types';
import { useState, useEffect } from 'react';
import TooltipContainer from '../TooltipContainer';

function DockLauncher({ icon, name, alwaysShow = false, appState, booleanAppState, onClickHandler }: {
  icon: JSX.Element,
  name: string,
  appState?: AppState,
  booleanAppState?: boolean,
  alwaysShow?: boolean
  onClickHandler: () => void
}) {
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    if (!alwaysShow) {
      if (appState === "closed") {
        const timer = setTimeout(() => setIsHidden(true), 250); // Delay hiding after 300ms
        return () => clearTimeout(timer); // Clean up timeout on unmount or state change
      }
      setIsHidden(false); // Reset visibility when not "closed"
    }
  }, [alwaysShow, appState]);

  return (
    <div className={`inline-flex relative ${!alwaysShow && (appState === "closed" ? "scale-0" : "")} ${isHidden ? "hidden" : ""}`}>
      <TooltipContainer className="md:mb-7" tooltip={name}>
        <div onClick={onClickHandler} className={`inline-flex p-4 text-4xl md:hover:scale-125 md:hover:-translate-y-4 md:active:scale-110 md:active:translate-y-0 transition-all duration-200 ease-in-out cursor-pointer w-16 flex-col items-center justify-center rounded-2xl text-zinc-100 hover:bg-zinc-800 active:bg-zinc-800 active:border-zinc-700`}>
          {icon}
          <span className={`absolute bottom-1 transition-all duration-200 ease-in-out h-1.5 ${appState === "minimized" && "w-2 rounded-full bg-red-500"} ${(appState === "maximized" || appState === "floating") && "w-6 rounded-full bg-red-500"} ${appState === "closed" && "w-0"} ${!appState && booleanAppState ? "w-6 rounded-full bg-red-500" : "w-0"}`}></span>
        </div>
      </TooltipContainer>
    </div>
  );
}

export default DockLauncher;
